import React from 'react';
import { cn } from '../../lib/utils';

const AnimatedLogo = ({ size = 'md', showText = true, className }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
    xl: 'w-20 h-20'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  const fontSizes = {
    sm: '0.6rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem'
  };

  // Inline styles to completely isolate from RTL transforms
  const logoContainerStyle = {
    direction: 'ltr',
    unicodeBidi: 'isolate',
    transform: 'none',
  };

  return (
    // Use ltr direction + unicode-bidi: isolate to prevent logo flip in RTL mode
    <div className={cn("flex items-center gap-2", className)} style={logoContainerStyle}>
      {/* Logo Icon */}
      <div className={cn(
        "relative rounded-xl overflow-hidden",
        sizeClasses[size]
      )}>
        {/* Gradient background */}
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-400 via-cyan-500 to-purple-600" />
        
        {/* Inner content */}
        <div className="absolute inset-[2px] rounded-[10px] bg-zinc-950 flex items-center justify-center">
          <div className="flex items-center justify-center" style={{ direction: 'ltr' }}>
            <span 
              className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400 font-black" 
              style={{ fontSize: fontSizes[size] }}
            >
              J
            </span>
            <span 
              className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-400 font-black" 
              style={{ fontSize: fontSizes[size] }}
            >
              A
            </span>
            <span 
              className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 font-black" 
              style={{ fontSize: fontSizes[size] }}
            >
              F
            </span>
          </div>
        </div>
      </div>

      {/* Logo Text */}
      {showText && (
        <span className={cn(
          "font-bold bg-gradient-to-r from-emerald-400 via-cyan-400 to-purple-400 bg-clip-text text-transparent",
          textSizeClasses[size]
        )}>
          JAF AI
        </span>
      )}
    </div>
  );
};

export default AnimatedLogo;
